import { VisibilitySpectrum } from '@/core/Common'
import { APIResource } from '@/core/resources/APIResource'

/**
 * Représente un spectre
 */

export class Spectrum extends APIResource {
  apiRoute: string = 'spectra'

  calc_key: string = ''
  short_name: string = ''
  visibility: VisibilitySpectrum = VisibilitySpectrum.DISPLAY
  collection_name: string = ''
  version: string = ''

  getIdentifier(): any {
    return this.calc_key
  }

  fromJson(json: SpectrumResponse): this {
    this.calc_key = json.calc_key
    this.short_name = json.short_name
    this.visibility = {
      '0': VisibilitySpectrum.DISPLAY,
      '1': VisibilitySpectrum.READY,
      '2': VisibilitySpectrum.HIDDEN
    }[json.hidden]!
    this.collection_name = json.collection_name
    this.version = json.version
    return this
  }
}

export interface SpectrumResponse {
  calc_key: string
  short_name: string
  hidden: string
  collection_name: string
  version: string
}

export default Spectrum
